// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".access-permission-list-item[data-v-02485260]:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 3px 10px 0 #ccc;\n  -webkit-transition: all 0.2s;\n}\n.access-permission-list-item[data-v-02485260] {\n  -webkit-transition: all 0.2s;\n}\n.right-arrow[data-v-02485260] {\n  transform: rotate(90deg);\n}\n.left-arrow[data-v-02485260] {\n  transform: rotate(-90deg);\n}\n.no-scroll[data-v-02485260]::-webkit-scrollbar {\n  width: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
